/* eslint-disable max-lines */
export enum ApprovalStatus {
  draft = 283800000,
  conceptReceived = 283800001,
  inStrategicPartnerManagerReview = 283800002,
  submittedForPortfolioReview = 283800003,
  inPortfolioReview = 283800004,
  approvedForXboxLive = 283800005,
  approvedForXboxLiveAndConsole = 283800006,
  approvedForXboxLiveConsoleAndERA = 283800007,
  rejectedByStrategicPartnerManager = 283800008,
  rejectedByPortfolioTeam = 283800009,
  needMoreInformationFromStrategicPartnerManagerReview = 283800010,
  needMoreInformationFromPublisher = 283800011,
  needMoreInvestigation = 283800012,
  onHold = 283800013,
}

export enum PitchStatus {
  draft = 751650000,
  submitted = 751650001,
  reviewed = 751650002,
}

export enum PitchSubmissionSource {
  external = 751650000,
  internal = 751650001,
}

export enum ProspectivePrograms {
  xboxGamePassForProspectivePrograms = 751650000,
  developerAcceletarionProgramPorting = 751650001,
  nestorFallsForProspectivePrograms = 751650002,
  developerAcceletarionProgramPrototype = 751650003,
  globalGamesFund = 751650004,
  otherProspectivePrograms = 751650005,
}

export enum StudioSizeStatic {
  OneToFourt = 751650000,
  FiveToTen = 751650001,
  TenToFifteen = 751650002,
  FifteenToTwentyFive = 751650003,
  TwentyFiveToFourtyFive = 751650004,
  FourtyFiveToAbove = 751650005,
}

export enum HavePublisherStatic {
  Yes = 751650000,
  No = 751650001,
  Negotiating = 751650002,
  Unsure = 751650003,
  SelfPublishing = 751650004,
}

export enum ApprovalSubStatus {
  approved = 751650000,
  rejectedSoftAlreadyHasPartnerCenterToken = 751650001,
  rejectedSoftSendDevCenterToken = 751650002,
  rejectedHard = 751650003,
  needMoreInfo = 751650004,
  needMoreInfoBuildLink = 751650005,
  needMoreInfoVideoLink = 751650006,
  needMoreInfoBuildAndVideoLink = 751650007,
  reviewSimShip = 751650008,
  reviewTooEarly = 751650009,
  rejectedSoftGeneral = 751650010,
}

export enum OnboardingDecisionChoice {
  approved = 751650000,
  denied = 751650001,
}

export enum YesNoChoice {
  yes = 100000000,
  no = 100000001,
}

export enum KitAlreadyStatic {
  Yes = 751650000,
  No = 751650001,
  Unknown = 751650002,
}

export enum ContainsNftOrBlockchainStatic {
  Yes = 751650000,
  No = 751650001,
  Unknown = 751650002,
}

export enum DevelopmentStageStatic {
  GameConcept = 751650000,
  Prototype = 751650001,
  Alpha = 751650002,
  Beta = 751650003,
  ClosedBeta = 751650004,
  OpenBeta = 751650005,
  ReadyToLaunch = 751650006,
  EarlyAccess = 751650007,
  Launched = 751650008,
}

export enum ReleasedPlatformsStatic {
  Sony = 751650000,
  Steam = 751650001,
  NintendoSwitch = 751650002,
  EpicStore = 751650003,
  Other = 751650004,
}

export enum targetedPlatformsStatic {
  SonyPlaystation = 751650000,
  Steam = 751650001,
  NintendoSwitch = 751650002,
  EpicStore = 751650003,
  Other = 751650005,
}

export enum GenreStatic {
  Action = 751650000,
  Adventure = 751650001,
  Arcade = 751650002,
  BattleRoyale = 751650003,
  FirstPersonThirdPersonShooter = 751650004,
  MOBA = 751650005,
  NarrativeStory = 751650006,
  MMORPG = 751650007,
  RolePlayingGame = 751650008,
  Sandbox = 751650009,
  Simulation = 751650010,
  SurvivalHorror = 751650011,
  Other = 751650012,
}

export enum GameEngineStatic {
  Unity = 751650000,
  UnrealEngine = 751650001,
  Godot = 751650002,
  Other = 751650003,
}

export enum BusinessModelStatic {
  Premium = 751650000,
  PremiumPaidDLC = 751650001,
  PremiumFreeDLC = 751650002,
  FreeToPlay = 751650003,
  GamesAsAService = 751650004,
  Other = 751650005,
}

export enum SensitiveContentStatic {
  Yes = 751650000,
  No = 751650001,
  Maybe = 751650002,
  Other = 751650003,
}

export enum FundingSoughtStatic {
  Yes = 751650000,
  No = 751650001,
  Other = 751650002,
}

const playerNumberToCrmChoice = [
  [1, 283800000],
  [2, 100000000],
  [3, 100000001],
  [4, 100000002],
  [5, 100000003],
  [6, 100000004],
  [7, 100000005],
  [8, 100000006],
];

export const [playerNumberToChoiceMap, choiceToPlayerNumberMap] = playerNumberToCrmChoice.reduce(
  ([toChoice, toNumber], value) => {
    toChoice.set(value[0], value[1]);
    toNumber.set(value[1], value[0]);
    return [toChoice, toNumber];
  },
  [new Map<number, number>(), new Map<number, number>()]
);

export enum ProgramType {
  invalid = 0,
  id = 283800000,
  onePP = 283800003,
  twoPP = 283800001,
  aaa = 283800002,
}

export enum AddressTypeCode {
  billing = 1,
  shipping = 2,
}

export enum BusinessImpact {
  low = 1,
  medium = 2,
  high = 3,
}

export enum PrimaryAccountType {
  publisher = 1,
  developer = 2,
}

export enum SecondaryAccountType {
  developer = 1,
  publisher = 2,
}

export enum ContractRequestStatus {
  draft = 9,
  submitted = 5,
  received = 6,
  contractProCreated = 3,
  routingApproval = 2,
  sentESig = 1,
  sentPdf = 7,
  sentOriginal = 10,
  fullyExecuted = 4,
  onHold = 8,
  canceled = 11,
  expired = 13,
  terminated = 12,
}

export const IDBreadthGUID = "756ed7a6-1801-ec11-94f0-000d3a4dc28d";
export const IDJapanGUID = "046d2f35-e327-ee11-9965-000d3a1abe9e";

export enum CvsApproval {
  approved = 751650001,
  pending = 751650000,
  rejected = 751650002,
}

export enum PartnerCenterEnrollmentStatus {
  Unset = 751650004,
  Enabled = 751650001,
  InProgress = 751650002,
  Complete = 751650003,
  Rejected = 751650000,
}

export enum ContractAPIStatus {
  SubmittedForAutomation = 751650000,
  SubmittedForRecall = 751650001,
  SubmittedForDeletion = 751650002,
  AssembleContractDocument = 751650003,
  CreateContractMetadata = 751650004,
  CreateAdditionalMetada = 751650005,
  AddingSGStakeholder = 751650006,
  SubmitContract = 751650007,
  SendContractForExternalSignature = 751650008,
  ContractRecalled = 751650009,
  ContractDeleted = 751650010,
  SubmittedForResend = 751650011,
  ResentForSignature = 751650012,
  uploadDocument = 751650013,
}

export enum contractTypeName {
  ADA = 751650051,
  GDK = 751650052,
  GDKHW = 751650054,
  HW = 751650053,
  HybridTLA = 751650055,
}

export enum ContactStateCode {
  Active = 0,
  Inactive = 1,
}

export enum ContractVendorUseCreateOptions {
  UseOGCAccountDetails = 751650000,
  UseSapVendorId = 751650001,
  Search = 751650002,
}

export enum SellerStatus {
  active = 751650000,
  inactive = 751650001,
}

export enum AppDevStatus {
  active = 751650000,
  notActive = 751650001,
  notPresent = 751650002,
}

export enum ContractStatusCode {
  eSignSent = 1,
  routingApproval = 2,
  created = 3,
  fullyExecuted = 4,
  submitted = 5,
  received = 6,
  pdfSent = 7,
  onHold = 8,
  draft = 9,
  originalSent = 10,
  cancelled = 11,
  terminated = 12,
  expired = 13,
}

export enum GDKPermissionSets {
  HW_SW_XBOX = 751650000,
  SW_XBOX = 751650001,
  HW = 751650002,
}

export enum StreamingEuProviders {
  Tencent = 751650000,
  Valve = 751650001,
  Nexon = 751650002,
  NetEase = 751650003,
  EA = 751650004,
  SmileGate = 751650005,
  Roblox = 751650006,
  TakeTwo = 751650007,
  EpicGames = 751650008,
  Ubisoft = 751650009,
  SquareEnix = 751650010,
  BandaiNamco = 751650011,
  Sony = 751650012,
  Nintendo = 751650013,
}

export enum ReSendNdaStatus {
  Send = 751650000,
}

export enum ReSendNdaApiStatus {
  InProgress = 751650000,
  Sent = 751650001,
}

export enum AaaHubAdmin {
  Yes = 751650000,
}

export enum GameConceptCreatedFor {
  SubmittedByPublisher = 751650004,
}

export enum HideShowGameConcept {
  Hide = 751650000,
  Show = 751650001,
}

export enum PitchStatusCode {
  PartnerDeleted = 751650001,
}

export enum OneVetStatusResult {
  Accepted = 751650000,
  Submitted = 751650001,
  InProgress = 751650002,
  Pass = 751650003,
  Fail = 751650004,
  Error = 751650005,
  NotStarted = 751650006,
  Cancelled = 751650007,
  Expired = 751650008,
  PassWithOverride = 751650009,
  Completed = 751650010,
  FailWithOverride = 751650011,
}

export type OneVetResponse = {
  oneVetUrlToVerifyUser: string | null;
  oneVetStatusResponse: OneVetStatusResult | null;
};
